const WORK_ORDER_CACHE_KEYS = [
  'id',
  'propertyId',
  'peopleId',
  'name',
  'date',
  'email',
  'phone',
  'property_address',
  'problem_description',
  'allow_entry',
  'sent_datetime',
  'modifiedOn',
  'startedOn',
  'startedByName',
  'completedOn',
  'completedBy',
  'note',
  'priority',
  'photoCount',
  'commentCount',
  'pet',
  'petName',
  'workOrderSpecialInstr',
  'scheduledDate',
  'scheduledTime',
  'calendarEventId',
  'scheduledBy',
  'tenantScheduled',
  'tenantFee',
  'tentativeDate',
  'tentativeTime',
  'viewedBy',
  'parentId',
  'parentAddress',
  'assignedTo',
  'assignedToName',
  'smsOptIn',
  'pixieNotifications',
  'nameIsStaff',
];

function workOrderCacheRecord(order) {
  const source = order || {};
  const cached = {};
  for (const key of WORK_ORDER_CACHE_KEYS) {
    if (source[key] !== undefined) cached[key] = source[key];
  }
  return cached;
}

function workOrderCacheNeedsFullReload(rows) {
  return (rows || []).some(
    (wo) =>
      wo &&
      ((wo.completedOn && !wo.completedBy) ||
        wo.commentCount == null ||
        !Object.prototype.hasOwnProperty.call(wo, 'startedOn') ||
        !Object.prototype.hasOwnProperty.call(wo, 'smsOptIn') ||
        !Object.prototype.hasOwnProperty.call(wo, 'pixieNotifications') ||
        !Object.prototype.hasOwnProperty.call(wo, 'nameIsStaff')),
  );
}

module.exports = {
  WORK_ORDER_CACHE_KEYS,
  workOrderCacheRecord,
  workOrderCacheNeedsFullReload,
};
